import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import ProjectStatsCards from "./ProjectStatsCards";
import TopProjectsByPolesTable from "./TopProjectsByPolesTable";
import TopUsersByProjectsTable from "./TopUsersByProjectsTable";
import OrganisationTotalsPie from "./OrganisationTotalsPie";
import LanguageTotalsPie from "./LanguageTotalsPie";
import DarkmodeTotalsPie from "./DarkmodeTotalsPie";

const StatisticsDashboard: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: 0,
        overflowY: "auto",
        height: "80%",
      }}
    >
      <Container
        disableGutters
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          py: 2,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, mb: 2 }}
            color="primary.contrastText"
          >
            Overview
          </Typography>
          <ProjectStatsCards />
          <Box sx={{ height: 20 }} />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                md: "1fr",
                lg: "1fr 1fr 1fr",
              },
              gap: 3,
            }}
          >
            <OrganisationTotalsPie />
            <LanguageTotalsPie />
            <DarkmodeTotalsPie />
          </Box>
        </Box>

        <Stack>
          <Typography variant="h5" sx={{ mb: 1 }} color="primary.contrastText">
            Projects with the most poles
          </Typography>
          <TopProjectsByPolesTable />
        </Stack>
        <Stack>
          <Typography variant="h5" sx={{ mb: 1 }} color="primary.contrastText">
            User with the most projects
          </Typography>
          <TopUsersByProjectsTable />
        </Stack>
      </Container>
    </Box>
  );
};

export default StatisticsDashboard;
